import('./bootstrap')
	.catch((_err) => {});
